/** Formatacao de valores e tempo. Dinheiro sempre em centavos inteiros. */

const BRL = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export function money(cents: number): string {
  return BRL.format(cents / 100);
}

/** mm:ss, ou m:ss.d quando resta menos de dez segundos. */
export function clock(ms: number): string {
  const seguro = Math.max(0, ms);
  const totalSegundos = Math.floor(seguro / 1000);
  const minutos = Math.floor(totalSegundos / 60);
  const segundos = totalSegundos % 60;

  if (seguro < 10_000) {
    const decimo = Math.floor((seguro % 1000) / 100);
    return `${minutos}:${String(segundos).padStart(2, '0')}.${decimo}`;
  }
  return `${minutos}:${String(segundos).padStart(2, '0')}`;
}

export const GAME_LABEL: Record<string, string> = {
  CHESS: 'Xadrez',
  CHECKERS: 'Damas',
  TIC_TAC_TOE: 'Jogo da velha',
};

/** Motivos vindos do motor, em texto para o jogador. */
export const REASON_LABEL: Record<string, string> = {
  TRES_EM_LINHA: 'três em linha',
  TABULEIRO_CHEIO: 'tabuleiro cheio',
  XEQUE_MATE: 'xeque-mate',
  AFOGAMENTO: 'afogamento',
  MATERIAL_INSUFICIENTE: 'material insuficiente',
  TRIPLA_REPETICAO: 'tripla repetição',
  REGRA_DOS_50_LANCES: 'regra dos 50 lances',
  SEM_PECAS: 'sem peças',
  SEM_LANCE_LEGAL: 'sem lance legal',
  VINTE_LANCES_SEM_PROGRESSO: '20 lances sem progresso',
  TEMPO_ESGOTADO: 'tempo esgotado',
  DESISTENCIA: 'desistência',
  ABANDONO: 'abandono',
};

export function reason(code: string): string {
  return REASON_LABEL[code] ?? code.toLowerCase().replace(/_/g, ' ');
}
